export function approvedGoogleConsent(data, success, cmpId) {
  if (success !== true || data?.cmpId !== cmpId || data.cmpStatus !== "loaded" || !["tcloaded", "useractioncomplete"].includes(data.eventStatus)) return false;
  if (data.gdprApplies === false) return true;
  return data.gdprApplies === true && typeof data.tcString === "string" && data.tcString.length > 0 &&
    data.vendor?.consents?.[755] === true && [1, 2, 3, 4, 7, 9, 10].every(id => data.purpose?.consents?.[id] === true);
}

// The reviewed CMP must already exist. Never infer jurisdiction or manufacture TC data.
export function observeAdSenseConsent(cmpId, callback) {
  let active = true, listenerId;
  if (typeof window.__tcfapi !== "function") { callback(false); return () => {}; }
  const api = window.__tcfapi;
  try {
    api("addEventListener", 2, (data, success) => {
      listenerId = data?.listenerId ?? listenerId;
      if (!active) { if (listenerId !== undefined) api("removeEventListener", 2, () => {}, listenerId); return; }
      callback(approvedGoogleConsent(data, success, cmpId));
    });
  } catch { callback(false); }
  return () => { active = false; if (listenerId !== undefined) { try { api("removeEventListener", 2, () => {}, listenerId); } catch { /* Callbacks already disabled. */ } } };
}
